module.exports = __webpack_public_path__ + "static/img/closer_port_lg.2d10145.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/the-closer-banner-campaign/closer_port_lg.jpg
// module id = 284
// module chunks = 2